export default "__VITE_ASSET__DduT3Roo__ 400w, __VITE_ASSET__CbK5_yld__ 800w, __VITE_ASSET__CJAeQKl7__ 1200w";